import { render } from "./IceVend.vue?vue&type=template&id=451ec183"
import script from "./IceVend.vue?vue&type=script&lang=js"
export * from "./IceVend.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__